import React from "react";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { Pill } from "@foris/avocado-suite";
import { Bundle } from "../../models/ISchema";
import { Header } from "../../common/components";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import styles from "@components/Header/header.module.scss";

interface IHeaderVacancies {
  data?: Bundle;
  isLoading?: boolean;
}

const HeaderVacancies: React.FC<IHeaderVacancies> = (props: IHeaderVacancies) => {
  const { t } = useTranslation();
  const course = props?.data?.links?.[0]?.course ?? ({} as Bundle["links"][0]["course"]);
  const { adaptedHomeUrl } = useNavigationUrl();

  return (
    <Header
      isLoading={
        props?.isLoading
          ? {
              breadcrumb: true,
              topTitle: true,
              title: true,
              moreDetails: true,
            }
          : undefined
      }
      breadcrumbItems={[
        {
          path: adaptedHomeUrl(),
          title: t("dimension.link.breadcrumb.previous"),
        },
        {
          title: t("bundle.title"),
        },
      ]}
      topTitle={`${t("bundle.code")}: ${props.data?.code}`}
      title={`${course?.code}, ${course?.name}`}
      subTitle={
        <div className={cx(styles.infoItem_subTitle, styles.infoItem_subTitleWrapper)}>
          {!!props?.data?.term?.code && (
            <Pill textColor="gray-10" color="gray-70">
              {t("dimension.link.label-pill")}: {props?.data?.term?.code}
            </Pill>
          )}
          <Pill textColor="gray-10" color="gray-70">
            {t("dimension.link.header.more-details.vacancies")}: {props?.data?.capacity ?? "-"}
          </Pill>
        </div>
      }
      moreDetails={[
        {
          title: t("bundle.link-card.group-table.body.subject-key.campus"),
          content: course?.curriculum?.program?.campus?.code || "-",
        },
        {
          title: t("bundle.link-card.group-table.body.subject-key.department"),
          content: course?.curriculum?.program?.department?.code || "-",
        },
        {
          title: t("bundle.link-card.group-table.body.subject-key.modality"),
          content: course?.curriculum?.program?.modality?.code || "-",
        },
        {
          title: t("bundle.link-card.group-table.body.subject-key.shift"),
          content: course?.curriculum?.program?.shift?.code || "-",
        },
        {
          title: t("bundle.link-card.group-table.body.subject-key.program"),
          content: course?.curriculum?.program?.code || "-",
        },
        {
          title: t("bundle.link-card.group-table.body.subject-key.level"),
          content: (course?.level ?? "-") as string,
        },
      ]}
    />
  );
};

export default HeaderVacancies;
